import { apiFetch } from '../config/api'

export type RootType = 'internal' | 'external'

export type PassSequenceImageQuery = {
  rootType: RootType
  capCount: number
  fillCount: number
}

export type PassSequenceImageAdminItem = {
  id: number
  rootType: RootType
  capCount: number
  fillCount: number
  updatedAt: string
  signedImageUrl: string | null
  fileKey: string
  imageUrl: string
}

export async function fetchPassSequenceImage(
  query: PassSequenceImageQuery
): Promise<{ imageUrl: string | null }> {
  const params = new URLSearchParams({
    root_type: query.rootType,
    cap: String(query.capCount),
    fill: String(query.fillCount)
  })
  return apiFetch(`/api/pass-sequence-images?${params.toString()}`)
}

export async function createPassSequenceImageUploadUrl(params: {
  fileName: string
  contentType: string
}): Promise<{ uploadUrl: string; fileKey: string; publicUrl: string }> {
  return apiFetch('/api/pass-sequence-images/upload-url', {
    method: 'POST',
    body: JSON.stringify(params)
  })
}

export async function registerPassSequenceImage(params: {
  rootType: RootType
  capCount: number
  fillCount: number
  imageUrl: string
  fileKey: string
}): Promise<{ id: number; imageUrl: string }> {
  return apiFetch('/api/pass-sequence-images', {
    method: 'POST',
    body: JSON.stringify(params)
  })
}

export async function listPassSequenceImagesAdmin(): Promise<{ items: PassSequenceImageAdminItem[] }> {
  return apiFetch('/api/pass-sequence-images/admin-list')
}

export async function deletePassSequenceImage(id: number): Promise<void> {
  await apiFetch(`/api/pass-sequence-images/${id}`, { method: 'DELETE' })
}
